import { Empty, Typography } from 'antd';
import WelcomeContainer from 'components/welcome-container/WelcomeContainer';
import { useTranslation } from 'react-i18next';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <WelcomeContainer>
      <Empty
        description={
          <Typography.Title level={1}>{t('pages._404.page_not_found')}</Typography.Title>
        }
      />
    </WelcomeContainer>
  );
}
